import IsServerSideRendering from './IsServerSideRendering';

const IsDocumentSafe = () => {
  if (IsServerSideRendering()) {
    return false;
  }

  try {
    return (typeof document !== 'undefined');
  } catch (e) {
    return false;
  }
};

export default IsDocumentSafe;
